import React from 'react';

import { ExtendedLiveReportList } from '@futrli/views/processors/dashboards/dashboardsList';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useDashboardActionItems } from '../../hooks/use-dashboard-action-items';

interface MyDashboardRowActionsProps {
  dashboard: ExtendedLiveReportList;
}

export const MyDashboardRowActions = ({ dashboard }: MyDashboardRowActionsProps) => {
  const items = useDashboardActionItems({ dashboard });

  return <ListingPageRowActions items={items} />;
};
